import { InjectionToken } from '@angular/core';

import { VerificationFacade } from './verification.facade';

export const VERIFICATION_FACADE = new InjectionToken<VerificationFacade>(
  'VERIFICATION_FACADE'
);